import React, { useState, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Cropper from 'react-easy-crop';
import { BaseContext } from '../contexts/baseContext';

export function ModalPersonalInfo({ children, title }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <i className="bi bi-pen" onClick={handleShow}></i>

      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <span className="close-modal" onClick={handleClose}>&times;</span>
          <Modal.Title>{ title }</Modal.Title>
          <div className="modal-form">
            { children }
          </div>
          <div className="modal-btn">
            <Button variant="primary" onClick={handleClose}>
              confirm
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export function ModalChangeProfilPhoto({ show, image, crop, zoom, onCropChange, onCropComplete, onZoomChange, setClose }) {
  return (
    <>
      <Modal show={show} onHide={() => setClose()} className="croppedArea">
        <Modal.Body>
          <span className="close-modal" onClick={() => setClose()} >&times;</span>

          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={onCropChange}
            onCropComplete={onCropComplete}
            onZoomChange={onZoomChange}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

export function ModalViewPhoto({ show, contact, setClose }) {
  const { touchContact, navigateTo } = useContext(BaseContext);
  const { nom, photo, id } = contact;

  return (
    <Modal centered show={show} onHide={() => setClose()} className="modal-view-photo" style={{ borderRadius: "0px" }}>
      <Modal.Body>
        <div className="modal-view-photo--body-header"> { nom }</div>

        <img src={ photo } alt="" className="imageProfil"/>
      </Modal.Body>
      <Modal.Footer className="modal-view-photo--footer">
        <i className="bi bi-chat-right-text-fill" onClick={() => { setClose(false); touchContact(id) }}></i>
        <i className="bi bi-info-circle" onClick={() => { setClose(false); navigateTo("profil-contact")}}></i>
      </Modal.Footer>
    </Modal>
  );
}
